import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import TresImmoPage from "./pages/TresImmoPage";
import WaldrandPage from "./pages/WaldrandPage";
import AdminPage from "./pages/AdminPage";
import BaufortschrittPage from "./pages/BaufortschrittPage";
import UnitPage from "./pages/UnitPage";
import ContentPage from "./pages/ContentPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LanguageProvider>
          <Routes>
            <Route path="/" element={<TresImmoPage />} />
            <Route path="/:lang" element={<TresImmoPage />} />
            <Route path="/waldrand" element={<WaldrandPage />} />
            <Route path="/baufortschritt" element={<BaufortschrittPage />} />
            <Route path="/:lang/waldrand" element={<WaldrandPage />} />
            <Route path="/:lang/baufortschritt" element={<BaufortschrittPage />} />
            <Route path="/:lang/einheiten/:id" element={<UnitPage />} />
            <Route path="/:lang/faq" element={<ContentPage />} />
            <Route path="/:lang/ratgeber" element={<ContentPage />} />
            <Route path="/:lang/bautagebuch" element={<ContentPage />} />
            <Route path="/:lang/fakten" element={<ContentPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/:lang/admin" element={<AdminPage />} />
          </Routes>
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
